class ReportGridSquareController {
    
    $onInit() {
        if (this.isComplete) {
            this.icon = 'fa-check';
            this.colorClass = 'complete';
            this.hoverText = 'Complete (View Report)'
        }
        else if (this.isInProgress) {
            this.icon = 'fa-hourglass-half';
            this.colorClass = 'in-progress';
            this.hoverText = 'In Progress';
        }
        else {
            this.icon = 'fa-minus';
            this.colorClass = 'not-started';
            this.hoverText = 'Not Started';
        }
    }


}

export default ReportGridSquareController;


// WEBPACK FOOTER //
// ./app/common/report-grid-square/report-grid-square-controller.js